/* RESPONSIBLE TEAM: team-workflows */
import type AppService from 'embercom/services/app-service';
import WorkflowsBaseRoute from 'embercom/routes/apps/app/settings/inbox-rules/workflows-base';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import type Store from '@ember-data/store';
import type Transition from '@ember/routing/transition';

export default class WorkflowsNewRoute extends WorkflowsBaseRoute {
  @service declare intercomEventService: $TSFixMe;
  @service declare appService: AppService;
  @service declare intl: IntlService;
  @service declare store: Store;

  beforeModel(_transition: Transition) {
    super.beforeModel(...arguments);

    this.store.findAll('inbox/ticket-type');

    if (this.appService.app.canUseFeature('disable-inbox-rules')) {
      this.transitionTo('apps.app.automation.workflows-overview');
    }
  }

  model() {
    let createParams = {
      name: this.intl.t('settings.inbox-rules.new.new-rule-name'),
      triggerTypes: ['inbound_conversation_started'],
    };

    return this.store.createRecord('workflow', createParams).save();
  }

  afterModel(model: $TSFixMe, _transition: Transition) {
    this.intercomEventService.trackEvent('workflows', {
      action: 'created',
      object: 'inbox_rule',
      place: 'inbox_automation',
      section: 'respond',
      rule_id: model.id,
    });
    let queryParams = { mode: 'create' };
    this.replaceWith('apps.app.settings.helpdesk.rules.edit', model.id, { queryParams });
  }
}
